import { calcTransferFee } from 'lib/revenue'

export const BASE_TRANSFER_FEE = 450
export const TRANSFER_FEE_RATE = 0.0025
export const MIN_TRANSFERABLE_AMOUNT = calcTransferFee(BASE_TRANSFER_FEE)
